












import Vue from "vue";
import { mapGetters } from "vuex";

export default Vue.extend({
    name: "Classifieds",

    data: function() {
        return {
            isMobile: true as boolean,
            mainSidebarSticky: false as boolean
        };
    },
    computed: {
        ...mapGetters({
            isMasquerading: "UserModule/isMasquerading",
        }),
    },
    mounted: function() {
        this.$responsive.registerMediaQuery("from-desktop", () => {
            this.isMobile = false;
            this.mainSidebarSticky = true;
        }, () => {
            this.isMobile = true;
            this.mainSidebarSticky = false;
        });

    },
});
